<template>
	<el-dialog

	title="新建项目"
	:visible.sync="visible"
	width="50%"
	:before-close="befclose" >
			<el-form v-if="!changeInfo" ref="formId" :rules="rules" :model="project" class="bm bm-ver form-info" label-position="right" size="small" label-width="120px">
				<div class="bm bm-ver">
					<el-row :gutter="10" class="bm bm-ac dept-info">
						<el-col :span="24" class="bm bm-ps bm-ac">
							<el-form-item label="项目名称" style="width:100%" prop="projectName" 
								:rules="{required: true, message: '请输入',trigger: 'change'}">
								<el-input v-model="project.projectName" size="small" clearable placeholder="请输入"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					
					<el-row :gutter="10" class="bm  bm-ac dept-info">
						<el-col :span="24" class="bm bm-ps bm-ac">
							<el-form-item label="项目归属部门" style="width:100%" prop="requestDepartName"
							:rules="{required: true, message: '请选择',trigger: 'change'}">
								<div class="" @click="openChoseDep">
									<el-input v-model="project.requestDepartName" size="small" clearable placeholder="请选择"></el-input>
								</div>
							</el-form-item>
						</el-col>
					</el-row>
					
					<el-row :gutter="10" class="bm  bm-ac dept-info">
						<el-col :span="24" class="bm bm-ps bm-ac">
							<el-form-item label="项目开始时间" style="width:100%" prop="startDate" 
								:rules="{required: true, message: '请选择',trigger: 'change'}">
								<el-date-picker
									style="width:100%"
									value-format="timestamp"
									v-model="project.startDate"
									type="date"
									placeholder="请选择">
									</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10" class="bm bm-ac dept-info">
						<el-col :span="24" class="bm bm-ps bm-ac">
							<el-form-item label="项目结束时间" style="width:100%" prop="endDate" 
								:rules="{required: true, message: '请选择',trigger: 'change'}">
								<el-date-picker
									style="width:100%"
									v-model="project.endDate"
									value-format="timestamp"
									type="date"
									placeholder="请选择">
									</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
			</el-form>
			<div slot="footer" v-if="!changeInfo" class="dialog-footer">
				<el-button @click="cancel">取消</el-button>
				<el-button :disabled="!finishShow" type="primary" @click="complete()">完成</el-button>
			</div>
			<el-form v-if="changeInfo" ref="formId" :rules="rules" :model="changeProject" class="bm bm-ver form-info" label-position="right" size="small" label-width="120px">
				<div class="bm bm-ver">
					<div>
						<el-row :gutter="10" class="bm bm-f1 bm-ac dept-info">
							<el-col :span="24" class="bm bm-ps bm-ac">
								<el-form-item label="项目名称" style="width:100%" prop="projectName" 
									:rules="{required: true, message: '请输入',trigger: 'change'}">
									<el-input :disabled="true" v-model="changeProject.projectName" size="small" clearable placeholder="请输入"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="10" class="bm bm-f1 bm-ac dept-info">
							<el-col :span="24" class="bm bm-ps bm-ac">
								<el-form-item label="项目归属部门" style="width:100%" prop="requestDepartName"
								:rules="{required: true, message: '请选择',trigger: 'change'}">
									<div class="">
										<el-input :disabled="true" v-model="changeProject.requestDepartName" size="small" clearable placeholder="请选择"></el-input>
									</div>
								</el-form-item>
							</el-col>
						</el-row>
						
						<el-row :gutter="10" class="bm bm-f1 bm-ac dept-info">
							<el-col :span="24" class="bm bm-ps bm-ac">
								<el-form-item label="项目开始时间" style="width:100%" prop="startDate" 
									:rules="{required: true, message: '请选择',trigger: 'change'}">
									<el-date-picker
										style="width:100%"
										value-format="timestamp"
										v-model="changeProject.startDate"
										type="date"
										placeholder="请选择">
										</el-date-picker>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="10" class="bm bm-f1 bm-ac dept-info">
							<el-col :span="24" class="bm bm-ps bm-ac">
								<el-form-item label="项目结束时间" style="width:100%" prop="endDate" 
									:rules="{required: true, message: '请选择',trigger: 'change'}">
									<el-date-picker
										style="width:100%"
										v-model="changeProject.endDate"
										value-format="timestamp"
										type="date"
										placeholder="请选择">
										</el-date-picker>
								</el-form-item>
							</el-col>
						</el-row>
					</div>			
				</div>
			</el-form>
			<div slot="footer" v-if="changeInfo" class="dialog-footer">
				<el-button @click="cancel">取消</el-button>
				<el-button :disabled="!finishShow1" type="primary" @click="completeChange()">完成</el-button>
			</div>
	</el-dialog>
	
</template>
<script>
import { $cacheUtil } from "@/utils";
// const R = require('ramda')
export default {
	props: {
		visible: {
			type: Boolean,
			required: true
		},
		projectData: {
			type: Object,
			required: false
		},
		changeInfo: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			//校验规则
            rules: {
            },
			finishShow:false,
			finishShow1:true,
            project:{
				"projectName": "",
				"projectCode": "",
				"requestDepartName": "",
				"requestDepartCode": "",
                "startDate": "",
                "endDate": "",
			},
			changeProject : {
				"projectName": "",
				"projectCode": "",
				"requestDepartName": "",
				"requestDepartCode": "",
                "startDate": "",
                "endDate": "",
			},
			inputDep: "",
		}
    },
    watch:{
		projectData:{//深度监听，可监听到对象、数组的变化
			handler(val, oldVal){
				console.log("更新",val)
				this.project.requestDepartName=val.requestDepartName;
				this.project.requestDepartCode=val.requestDepartCode
			},
			deep:true
		},
        project: {
			handler: function(newValue, oldValue) {
				let _this=this;
                if(JSON.stringify(newValue) != '{}' && !_this.changeInfo){
					_this.$refs.formId.validate(valiede => {
						_this.finishShow = valiede;
					})	
                }
			},
			immediate: false,
			deep: true
		}
		
	},
	mounted(){
		this.project.requestDepartName=this.projectData.requestDepartName;
		this.project.requestDepartCode=this.projectData.requestDepartCode
		let param =$cacheUtil.getObject("generalProject");
		this.changeProject.projectName=param.projectName;
		this.changeProject.projectCode=param.projectCode;
		this.changeProject.requestDepartName=param.requestDepartName;
		this.changeProject.requestDepartCode=param.requestDepartCode;
		this.changeProject.startDate=param.startDate;
		this.changeProject.endDate=param.endDate;
	},
	methods:{
		befclose(){
			this.$emit("cancel");
		},
		complete(){
			this.$emit("complete",this.project);
		},
		completeChange(){
			this.$emit("complete",this.changeProject);
		},
        cancel(){
            this.$emit("cancel");
		},
		openChoseDep(){
			this.$emit("openChoseDep")
		}
	}
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
	/deep/.el-dialog__body {
		padding: 20px 20px;
		display: flex;
		align-items: center;
    	overflow: auto;
		.form-info{
			height: 100%;
			width: 100%;
			.dept-info{
                height: 50%;
                margin-bottom: 10px;
				.futurePrice{
                    position: relative;
                    .unit{
                        z-index: 100;
                        position: absolute;
                        top: 8px;
                        right: 40px;
                        font-size: 14px;
                        color: #969696;
                    }
                }
            }

			.device-list{
				.device-list-row {
					margin-top: 30px;
				}
				.device-list-row:first-child{
					margin-top: 0px;
				}
			}
			.device-title{
				margin-left: 20px;
				margin-bottom: 10px;
				font-size: 16px;
				line-height: 16px;
				color: #323232;
				.device-model{
					font-size: 12px;
					color: #969696;
					margin-left: 9px;
					line-height: 12px;
				}
			}
			.add-device{
				margin-left: 20px;
				margin-top: 20px;
				font-size: 14px;
				line-height: 14px;
				color: #409eff;
			}
			.device-info-row{
				border: solid 1px #dcdfe5;
				padding: 20px 20px 2px 20px;
				.price{
					font-size: 14px;
					line-height: 14px;
					color: #ff3507;
					margin-left: 30px;
				}
				.del-btn{
					height: 50px;
				}
			}
			.el-input--small .el-input__inner{
				height: 36px;
				line-height: 36px;
			}
			.el-input-number__increase, .el-input-number__decrease{
				top: 2px;
				height: 28px;
			}
		}
		
	}
}
</style>
